import {axiosClient} from '../axios';

import type {
  ProductAggregatedNotesType,
  ProductReview,
  UserReviewsQueryParams,
  UserReviewsMetadata,
} from '../types';
import {
  convertFiltersToSearchString,
  FiltersOf,
  getPaginatedFiltersMapping,
  getViewKeyHeader,
  MaybePaginatedGetter,
  ViewKeyOptions,
} from '../utils';

export const getProductAggregatedNotes = async (
  productUuid: string,
  viewKey?: string,
): Promise<ProductAggregatedNotesType> => {
  const {data} = await axiosClient.get<ProductAggregatedNotesType>(
    `user-reviews/${productUuid}/notes/`,
    {headers: getViewKeyHeader(viewKey)},
  );
  return data;
};

const userProductReviewsFiltersMapping = getPaginatedFiltersMapping({
  own: 'my',
  type: 'type',
  brand: 'brand',
  order: 'order_by',
  rating: 'rating',
  country: 'country',
  category: 'category',
  productUuid: 'product_uuid',
});

export const getUserProductReviews: MaybePaginatedGetter<
  ProductReview,
  FiltersOf<typeof userProductReviewsFiltersMapping>
> = async (filters?: UserReviewsQueryParams, options?: ViewKeyOptions) => {
  const {data} = await axiosClient.get(
    `user-reviews/${convertFiltersToSearchString(
      filters,
      userProductReviewsFiltersMapping,
    )}`,
    {headers: getViewKeyHeader(options?.viewKey)},
  );
  return data;
};

export const getUserReviewsMetadata = async (
  viewKey?: string,
): Promise<UserReviewsMetadata> => {
  const {data} = await axiosClient.get<UserReviewsMetadata>(
    `user-reviews/metadata/`,
    {headers: getViewKeyHeader(viewKey)},
  );
  return data;
};
